import { config } from "config";
import { ITrackingInfoPage, ITrackingInfoEvent } from "types/tracking";
import { IAPITarget } from "./NetworkStapler";

export const LUX_TRACKING_URL = "/lux-collector-internet/rest/atomicevents";

export function postLuxTracking(body: ITrackingInfoPage | ITrackingInfoEvent): IAPITarget {
    return {
        url: LUX_TRACKING_URL,
        headers: {
            "Content-Type": "application/vnd.at.spardat.misol.lux.entities.atomic.event+json",
            "Accept": "application/vnd.at.spardat.misol.lux.entities.atomic.event+json",
            "ApiKey": config.network.luxApiKey
        },
        method: "POST",
        body,
    };
}


// WEBPACK FOOTER //
// ./src/network/LuxAPI.ts